import React, { useState } from "react";
import "./mobileLocationMap.scss";

const locations = [
    {
        id: 1,
        name: "Shree Swami Samarth Temple",
        distance: 5.5,
        icon: "🛕",
        position: { top: "32%", left: "75%" }
    },
    {
        id: 2,
        name: "Solapur Airport",
        distance: 3.5,
        icon: "✈️",
        position: { top: "40%", left: "50%" }
    },
    {
        id: 3,
        name: "Tulja Bhavani Temple",
        distance: 45,
        icon: "🛕",
        position: { top: "20%", left: "90%" }
    },
    {
        id: 4,
        name: "Pandharpur Temple",
        distance: 75,
        icon: "🛕",
        position: { top: "10%", left: "20%" }
    },
    {
        id: 5,
        name: "Naldurg Fort",
        distance: 40,
        icon: "🏰",
        position: { top: "50%", left: "15%" }
    }
];

const MobileLocationMap = () => {
    const [selected, setSelected] = useState(locations[0]);

    // 🔥 Handle selection properly
    const handleSelect = (item) => {
        console.log("Selected:", item); // debug
        setSelected({ ...item }); // force new reference
    };

    return (
        <div className="mapUI">

            <div className="map centerMap">
                <div className="mapBg"></div>

                {/* 🏠 CENTER HOME */}
                <div className="homeCenter">🏠</div>

                {/* 📍 LOCATIONS AROUND */}
                {locations.map((loc) => (
                    <div
                        key={loc.id}
                        className={`mapPin ${selected.id === loc.id ? "active" : ""}`}
                        style={{
                            top: loc.position.top,
                            left: loc.position.left
                        }}
                        onClick={() => handleSelect(loc)}
                    >
                        <div className="pinIcon">{loc.icon}</div>
                        <span className="distance">{loc.distance} km</span>
                    </div>
                ))}
            </div>

            {/* 📦 BOTTOM SHEET */}
            <div className="bottomSheet">

                <div className="dragBar"></div>

                <div className="cardTop">

                    <div className="info">
                        <h3>{selected.name}</h3>
                        <p>
                            <span className="tag">{selected.type}</span>
                            📍 {selected.distance} km away
                        </p>
                        <p className="desc">
                            A famous place known for its beauty and history...
                        </p>
                    </div>

                    <div className="bookmark">🔖</div>
                </div>

                {/* 🔥 NEARBY */}
                <div className="nearby">
                    <div className="nearbyHeader">
                        <h4>Nearby places</h4>
                    </div>

                    <div className="nearbyList">
                        {locations.map((item) => (
                            <div
                                key={item.id}
                                className={`nearCard ${selected.id === item.id ? "active" : ""
                                    }`}
                                onClick={() => handleSelect(item)}
                            >
                                <div className="icon">{item.icon}</div>
                                <h5>{item.name}</h5>
                                <p>{item.distance} km</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default MobileLocationMap;